import React from 'react';
import { connectToStore } from '../../../store';
import styles from './ExpertDetails.module.scss';

function ExpertDetails() {
	return <div className={styles.expertDetails}>Expert Details - Work in Progress</div>;
}

export default connectToStore(ExpertDetails);
